import Vue from "vue";
import Vuex from "vuex";
import Type from "./types";
import Util from '@/utils/utils';

Vue.use(Vuex);

const state = {
  scrollTop: 0,
  token: "",
  userInfo: {},
  login: false
};

const getters = {
  getScrollTop: state => state.scrollTop,
  isLogin: state => state.login,
  getUserInfo: state => state.userInfo
};

const mutations = {
  [Type.SET_SCROLL_TOP]: (state, scrollTop) => {
    state.scrollTop = scrollTop;
  },
  [Type.SET_TOKEN]: (state, token) => {
    state.token = token;
    Util.setToken(token);
  },
  [Type.SET_USER_INFO]: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  [Type.SET_LOGIN]: (state, login) => {
    state.login = login;
  }
};

const actions = {};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: []
});
